var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#2A38A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.722 20.9723V17.0834C29.722 12.2223 27.7776 10.2778 22.9165 10.2778H17.0831C12.222 10.2778 10.2776 12.2223 10.2776 17.0834V22.9167C10.2776 27.7778 12.222 29.7223 17.0831 29.7223H20.972",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4597 22.4209L17.7736 19.4167C18.1042 18.9889 18.7167 18.9112 19.1444 19.2417L20.9236 20.6417C21.3514 20.9723 21.9639 20.8945 22.2944 20.4765L24.5403 17.5792",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2721 23.714L27.5444 24.2681C27.6805 24.5404 28.0207 24.7931 28.3221 24.8515L28.6916 24.9098C29.7999 25.0945 30.0624 25.9112 29.2652 26.7181L28.9249 27.0584C28.7013 27.2917 28.5749 27.739 28.643 28.0501L28.6916 28.2543C28.993 29.5959 28.2832 30.1112 27.1166 29.4112L26.8638 29.2654C26.5624 29.0904 26.0763 29.0904 25.7749 29.2654L25.5221 29.4112C24.3457 30.1209 23.636 29.5959 23.9471 28.2543L23.9957 28.0501C24.0638 27.739 23.9374 27.2917 23.7138 27.0584L23.3735 26.7181C22.5763 25.9112 22.8388 25.0945 23.9471 24.9098L24.3166 24.8515C24.6082 24.8029 24.9582 24.5404 25.0943 24.2681L25.3666 23.714C25.8916 22.6543 26.7471 22.6543 27.2721 23.714Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIcon);
export default __webpack_public_path__ + "static/media/loanIcon.39605e004e8dbe516316d71cdc7f86ed.svg";
export { ForwardRef as ReactComponent };